import useSessionStorageState from 'use-session-storage-state';

export const useJustSubmittedIndividualConsent = () =>
    useSessionStorageState<boolean | undefined>(
        'justSubmittedIndividualConsent'
    );
